"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EngageService = void 0;
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Throw and listen to events from parent window.
 */
var EngageService = exports.EngageService = /*#__PURE__*/_createClass(function EngageService() {
  var _this = this;
  _classCallCheck(this, EngageService);
  _defineProperty(this, "_targetWindow", void 0);
  _defineProperty(this, "receiveMessage", function (a) {
    if (a.data && a.data.type) {
      //  console.log('Game Got Engage Command')
      switch (a.data.type) {
        // tells game to update balance form server and the wallet syste
        /*  case "updateBalance": {
            //   console.warn('UPDATE BALANCE THROUGH ENGAGE')
            CORE.dispatch(RequestBalance());
            break;
          }
          //dispattches games current balance state.
          case "getBalance": {
            break;
          }*/
        case "send":
          {
            _Core["default"].dispatch(a.data.data);
          }
        default:
          {}
      }
    }
  });
  _defineProperty(this, "post", function (action, payload) {
    //   console.log('POST MESSAGE')
    _this._targetWindow.postMessage({
      type: action,
      data: payload
    }, "*");
  });
  if (window.parent) this._targetWindow = window.parent;else this._targetWindow = window;
  window.addEventListener("message", this.receiveMessage, false);
});
//# sourceMappingURL=engageService.js.map